import { styled } from '@/styled-system/jsx';

import RenterProfileForm from 'app/shared/modules/RenterProfileForm';
import Text from 'app/shared/core/Text';

export const StyledRenterProfilePopup = styled('div', {
  base: {
    display: 'flex', // Change to flex to create proper layout with sticky footer
    flexDirection: 'column',
    position: 'relative',
    height: '100%', // Take full modal height
    paddingTop: '16px',
    paddingLeft: '16px',
    paddingRight: '16px',
    width: '100%',
    boxSizing: 'border-box', // Ensure padding is included in width calculations
  },
});

export const ModalTitle = styled(Text, {
  base: {
    flexShrink: 0,
    fontWeight: 700,
    paddingTop: '16px',
    textAlign: 'center',
  },
});

export const ScrollWrapper = styled('div', {
  base: {
    flexGrow: 1, // Take remaining space above footer
    flexShrink: 1, // Take remaining space above footer
    flexBasis: 0, // Take remaining space above footer
    overflowY: 'auto', // Allow scrolling within this area
    overflowX: 'hidden',
    paddingRight: '8px', // Account for scrollbar space
    boxSizing: 'border-box',
    // Custom scrollbar styles
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#a8a8a8',
    },
  },
});

export const StyledRenterProfileForm = styled(RenterProfileForm, {
  base: {
    // Let the form take up available space and be scrollable if needed
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    minHeight: 0, // Allow flex shrinking
  },
});

export const ButtonFooter = styled('footer', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    flexShrink: 0,
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px',
    // Margins force footer to fill entire bottom space of the modal.
    marginRight: '-16px',
    marginLeft: '-16px',
    marginBottom: '-16px',
    background: 'hpxWhite',
    borderTopWidth: '1px',
    borderTopStyle: 'solid',
    borderTopColor: 'hpxGrey400',
    boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.15)',
    zIndex: 1001,
  },
});
